import(/* webpackMode: "eager" */ "/app/src/app/tools/sample-data-generator/page.tsx");
